import Vue from 'vue'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import rules from '@shared/validators/rules.js'

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule])
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
